<template>
  <div>
    <v-card
      class="my-3 d-flex flex-row align-start align-sm-center pa-2"
      color="#fff6df"
      style="border: 1px solid #ebdbb2"
      flat
      outlined
      :loading="loading"
    >
      <div
        :style="'width: ' + (isMobile ? '90' : '150') + 'px'"
        class="mr-2 d-none d-sm-flex"
        v-if="icon"
      >
        <v-img
          height="80"
          contain
          :src="'https://www.eyedock.com/images/pathologies/' + icon"
        ></v-img>
      </div>
      <div class="pl-4 d-flex flex-row flex-wrap flex-grow-1">
        <div>
          <div v-if="title" :class="category ? 'text-h4' : 'text-h5'">
            <span v-if="search">{{ title }}</span>
            <span v-else>{{ title | titleize }}</span>
          </div>
          <div class="caption ml-2">Click a condition to see more details</div>
        </div>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <div style="width: 200px" class="mt-2 mt-sm-0">
          <v-text-field
            rounded
            solo
            v-model="filter"
            placeholder="filter"
            clearable
            dense
            flat
            class="compact-select"
          ></v-text-field>
        </div>
      </div>
    </v-card>

    <div v-if="list && list">
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="pointer elevation-0"
        hide-default-footer
        disable-pagination
        @click:row="rowClick"
        v-if="$vuetify.breakpoint.smAndUp"
        :no-data-text="noResultsMessage"
      >
        <template v-slot:item.images="{ item }">
          <div style="width: 160px; height: 90px">
            <image-thumbnail
              :width="150"
              :img="item.images[0]"
              root="https://www.eyedock.com/images/ocular_conditions/"
              thumbRoot="https://www.eyedock.com/images/ocular_conditions/thumbnails/"
            ></image-thumbnail>
            <!-- <v-img
              max-width="150"
              max-height="80"
              class="my-1"
              contain
              v-if="item.images && item.images[0]"
              :src="imagePath + item.images[0]"
            >
            </v-img> -->
          </div>
        </template>
        <template v-slot:item.condition="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:item.symptoms="{ item }">
          {{ contentForKey(item, "symptoms") | truncate(truncate) }}
        </template>
        <template v-slot:item.signs="{ item }">
          {{ contentForKey(item, "signs") | truncate(truncate) }}
        </template>
        <!-- <template v-slot:item.work_up="{ item }">
          {{ contentForKey(item, "work_up") | truncate(truncate) }}
        </template>
        <template v-slot:item.treatment="{ item }">
          {{ contentForKey(item, "treatment") | truncate(truncate) }}
        </template> -->
      </v-data-table>

      <!-- for small screens -->
      <v-data-table
        v-else
        :headers="[{ text: 'Condition', value: 'name' }]"
        :items="list"
        class="pointer elevation-0"
        hide-default-footer
        hide-default-header
        @click:row="rowClick"
      >
        <template v-slot:item.name="{ item }">
          <v-card flat class="mx-0 text-left my-2" color="transparent">
            <div class="text-h5 my-2">{{ item.name }}</div>
            <v-divider></v-divider>
            <div class="d-flex flex-column justify-start">
              <div class="my-1">
                <b>Symptoms: </b>
                {{ contentForKey(item, "symptoms") | truncate(truncate) }}
              </div>
              <div class="my-1">
                <b>Signs: </b>
                {{ contentForKey(item, "signs") | truncate(truncate) }}
              </div>
              <!-- <div class="my-1">
                <b>Work-up: </b>
                {{ contentForKey(item, "work_up") | truncate(truncate) }}
              </div>
              <div class="my-1">
                <b>Treatment: </b>
                {{ contentForKey(item, "treatment") | truncate(truncate) }}
              </div> -->
            </div>
            <div class="linkLike text-right">more..</div>
          </v-card>
        </template>
      </v-data-table>
    </div>
    <div v-if="loading" class="mt-4">
      <v-skeleton-loader
        v-for="cnt in 7"
        :key="cnt"
        class="mx-2 my-1"
        width="98%"
        height="90"
        type="card"
      ></v-skeleton-loader>
    </div>
    <!-- {{ list }} -->
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import ImageThumbnail from "@/components/universalStuff/ImageThumbnail";

export default {
  name: "ConditionsForCategory",
  components: { ImageThumbnail },
  props: {
    category: null,
    search: null,
  },
  data: function () {
    return {
      list: null,
      loading: false,
      title: null,
      icon: null,
      filter: null,
      imagePath: "https://eyedock.com/images/ocular_conditions/",
      apis: {
        category: "/condition/category/",
        search: "/condition/deepSearch/",
      },
      headers: [
        {
          text: "Image",
          value: "images",
          sortable: false,
        },
        {
          text: "Condition",
          value: "name",
          sortable: true,
          cellClass: "cellText font-weight-medium",
        },
        {
          text: "Symptoms",
          value: "symptoms",
          sortable: false,
          cellClass: "cellText",
        },
        {
          text: "Signs",
          value: "signs",
          sortable: false,
          cellClass: "cellText",
        },
        // {
        //   text: "Work-Up",
        //   value: "work_up",
        //   sortable: false,
        //   cellClass: "cellText",
        // },
        // {
        //   text: "Treatment",
        //   value: "treatment",
        //   sortable: false,
        //   cellClass: "cellText greenBkg",
        // },
      ],
    };
  },
  methods: {
    rowClick(row) {
      // console.log(row);
      let url = `/ocular-conditions/details/${row.slug}`;
      this.$router.push({ path: url });
    },
    callApi() {
      // console.log("condition API");
      this.list = null;
      this.loading = true;
      let cat = this.category;
      if (!cat && !this.search) return; // show error?
      let api = cat ? this.apis.category : this.apis.search;
      let q = cat ? cat : this.search;
      // console.log(api + q);
      // ApiServices.conditionsForCategory(this.category)
      ApiServices.genericApiCall(api + q)
        .then((response) => {
          this.list = response.data?.items;
          this.title = response.data?.meta?.name;
          this.icon = response.data?.meta?.icon;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    contentForKey(item, key) {
      let text = item?.[key];

      // (content values were initially an array of strings, now is just a string).
      if (!text) text = "-";
      if (text.constructor === Array) {
        // if it's an array convert it to a string
        let textArr = text;
        text = textArr.join(". ");
        if (textArr.length > 1) text += " ..";
      }
      // remove markdown links
      // text = text.replace(/\[([^\0]*?)\]\([^\0]*\)/gim, "$1");
      text = text.replace(/\[(.*?)\]\(.*?\)/gim, "$1");
      // remove markdown bold
      text = text.replace(/\*\*([^\0]*)\*\*/gim, "$1");
      return text;
    },
  },
  computed: {
    truncate: function () {
      return this.isMobile ? 70 : 120;
    },
    filteredList: function () {
      if (!this.filter) return this.list;
      let lcFilter = this.filter.toLowerCase();
      return this.list.filter((obj) => {
        return obj.name.toLowerCase().includes(lcFilter);
      });
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    noResultsMessage: function () {
      let msg = "No ocular conditions ";
      msg += this.search ? `matching '${this.search}'` : "found";
      return msg;
    },
  },
  watch: {
    category() {
      if (this.category) this.callApi();
    },
    search() {
      if (this.search) this.callApi();
    },
  },
  mounted() {
    // console.log("search: ", this.search);
    if (this.category || this.search) this.callApi();
  },
  metaInfo() {
    return {
      title: "EyeDock/Conditions | " + this.title,
    };
  },
};
</script>

<style>
tbody tr:nth-of-type(odd) {
  background-color: #f2f8ff;
}

.cellText {
  font-size: 8pt;
  color: #000;
  padding: 8px 4px;
  /* vertical-align: top; */
}
.greenBkg {
  background-color: #e1ffdf;
}
</style>
